import React from "react";
import "../../App.css";
import Footer from "../Footer";
import TeamGrid from "./team/TeamGrid";
import teamMembers from "./team/teamMembers";
import "./team/TeamGrid.css";

export default function Team() {
  return (
    <>
      <div class="team">
        <div class="team-content">
          <h1>MEET THE TEAM</h1>
        </div>
      </div>
      <div className="container mx-auto px-4 py-8">
        <TeamGrid members={teamMembers} />
      </div>
      <Footer />
    </>
  );
}
